var map = {
	"./": "2NXm",
	"./index": "2NXm",
	"./index.vue": "2NXm",
	"./register": "1cHr",
	"./register.vue": "1cHr",
	"./register/step1": "kqmt",
	"./register/step1.vue": "kqmt",
	"./register/step2": "ThIQ",
	"./register/step2.vue": "ThIQ",
	"./register/step3": "pLVQ",
	"./register/step3.vue": "pLVQ",
	"./register/step4": "i6Ki",
	"./register/step4.vue": "i6Ki"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31BR";


//////////////////
// WEBPACK FOOTER
// /src/pages ^\.\/.*$
// module id = 31BR
// module chunks = 1